import React from 'react';
import logoImage from '../assets/pkd_logo.jpeg';

function MembershipHeader({showAddress = true}) {
    
    
    return ( 
        <div className="membership-form-card">
            {/* Document Header */}
            <div className="membership-header">
                <div className="membership-header-logo">
                    <img src={logoImage} alt="ISPKD Logo" />
                </div>

                <h1>INDIAN SOCIETY OF POLYCYSTIC KIDNEY DISEASE (ISPKD)</h1>

                {
                    showAddress &&
                    <>
                        
                <p>
                    <strong>Registered Office:</strong> No: 601, Abhinandana Jewel, Lanco Hills road, Manikonda,<br/>
                    Hyderabad, Telangana<br/>
                    <strong>Website:</strong> www.ispkd.com | <strong>Email:</strong> info@ispkd.com
                </p>
                    </>
                }
                
                
            </div>
        </div>
    );
}

export default MembershipHeader;